import React, { useState } from "react";
import { Button, Empty, Spin } from "antd";
import Card from "components/card";
import { urls } from "helpers/urls";
import { useFetch } from "hooks/useFetch";
import Request from "helpers/request";

const MostAskQuestion = () => {
  const [callAgain, setCallAgain] = useState([0]);
  const [updateLoading, setUpdateLoading] = useState(false);

  const handleComplete = (responseData) => {
    if (responseData?.status_code === 404) {
      setUpdateLoading(true);
      Request.postJson(urls.updateTopDiscussTopics, {})
        .then((response) => {
          if (response?.status_code === 200) {
            setCallAgain([Math.random()]);
          }
        })
        .catch((error) => {
          console.error("Update discuss topic", error?.response?.data?.message);
        })
        .finally(() => {
          setUpdateLoading(false);
        });
    }
  };

  const { data, loading, error } = useFetch({
    url: urls.getToDisccussTopics,
    dependencyList: callAgain,
    onCompleted: handleComplete,
  });

  const onPressRefresh = () => {
    setCallAgain([Math.random()]);
  };

  return (
    <Card
      extra="most-asked-questions-card"
      style={{ border: "1px solid #81aae780" }}
    >
      <div className="most-asked-questions-header">
        <h2>Top Most Topics (In Last 30 Days)</h2>
        <Button
          disabled={loading || updateLoading}
          className="rounded-md bg-[#2369d2] py-2 px-4 text-sm font-medium text-white"
          style={{ fontFamily: "figtree" }}
          onClick={onPressRefresh}
        >
          Refresh
        </Button>
      </div>

      {/* Loading Spinner */}
      {loading || updateLoading ? (
        <div className="loading-container">
          <Spin size="large" tip="Loading topics..." />
        </div>
      ) : error ? (
        <div className="error-container">{error}</div>
      ) : // Render List
      data?.status_code === 404 ? (
        <div className="error-container">
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description={data?.detail?.message || "No Data Found"}
          />
        </div>
      ) : (
        <ul className="most-asked-questions-list">
          {data?.data?.aggregated_topics?.map((item, index) => (
            <li key={index} className="question-item">
              <div className="question-number-container">
                <div className="question-number">{index + 1}</div>
              </div>
              <div className="question-details">
                <p className="question-text">{item?.name}</p>
                <p className="question-asked-description">
                  {item?.description}
                </p>
              </div>
              <div className="question-asked-count-container">
                <div className="question-asked-count">
                  {item?.count} time{item?.count && item?.count > 1 ? "s" : ""}
                </div>
              </div>
            </li>
          ))}
        </ul>
      )}
    </Card>
  );
};

export default MostAskQuestion;
